import axios from "axios";

/**
 * Fetch the discovery page payload for a city.
 *
 * @param {string} state - URL slug for the state (e.g. "arizona")
 * @param {string} city - URL slug for the city (e.g. "phoenix")
 * @returns {Promise<{cluster: object, lists: array}>}
 */
export async function fetchDiscoveryData(state, city) {
  const res = await axios.get(
    `/api/discovery/${encodeURIComponent(state)}/${encodeURIComponent(city)}`
  );
  return res.data;
}
